import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

const API_URL = environment.admin.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class AdminApiService {

  constructor(private http: HttpClient) {}

  getUsers(limit = 25, cursor?: string | null): Observable<any> {
    const params: Record<string, string> = {
      queryType: 'get-all-users',
      limit: String(limit)
    };
    if (cursor) params['cursor'] = cursor;
    return this.http.get(`${API_URL}`, {
      params
    });
  }

  getUserById(userId: string): Observable<any> {
    return this.http.get(`${API_URL}`, {
      params: { queryType: 'get-user-by-id', userid: userId }
    });
  }

  setAssessmentAttemptBlocked(userId: string, blocked: boolean): Observable<any> {
    return this.http.post(`${API_URL}`, {
      flow_selected: 'set-assessment-attempt-blocked',
      userId,
      blocked
    });
  }

  setUserResume(userId: string, resumeUrl: string, resumeKey: string): Observable<any> {
    return this.http.post(`${API_URL}`, {
      flow_selected: 'set-user-resume',
      userId,
      resumeUrl,
      resumeKey
    });
  }

  inviteUser(user: { email: string; firstName: string; lastName: string; role: string }): Observable<any> {
    return this.http.post(`${API_URL}`, {
      flow_selected: 'invite-user',
      ...user
    });
  }

  deleteUser(userId: string): Observable<any> {
    return this.http.post(`${API_URL}`, {
      flow_selected: 'delete-user',
      userid: userId
    });
  }

  getUserScores(userId: string): Observable<any> {
    return this.http.get(`${API_URL}`, {
      params: { queryType: 'get-scores-by-id', userid: userId }
    });
  }

  getUserDashboard(userId: string, sessionId: string): Observable<any> {
    return this.http.get(`${API_URL}`, {
      params: {
        queryType: 'get-user-dashboard',
        userid: userId,
        sessionid: sessionId
      }
    });
  }

  setAssessmentState(userId: string, sessionId: string, state: string): Observable<any> {
    return this.http.post(`${API_URL}`, {
      flow_selected: 'set-assessment-state',
      userId,
      sessionId,
      state
    });
  }

  setAssessmentObject(
    userId: string,
    sessionId: string,
    assessmentObj: any,
    flag: 'CREATE-NEW' | 'UPDATE-OLD'
  ): Observable<any> {
    return this.http.post(`${API_URL}`, {
      flow_selected: 'set-assessement-obj-user',
      userId,
      sessionId,
      assessmentObj,
      flag
    });
  }
}
